import Vue from 'vue'
import VueRouter from 'vue-router'
import { CognitoAuth } from '@/services/Auth/cognito';

Vue.use(VueRouter)

const routes = [ { path: '/auth/callback', name: 'AuthCallback', component: () => import('@/views/AuthCallback.vue'), meta: { rule: 'isPublic' } },
	{
		path: '/',
		component: () => import('./layouts/MainLayout'),
		children: [
			{
				path: '',
				name: 'home',
				component: () => import('./views/HomePage'),
				meta: {
					title: "Inversión y financiamiento sostenible.",
					metaTags: [
						{
						  name: 'description',
						  content: 'La Fintech sostenible de México. Invierte y promueve el desarrollo sostenible en México por medio de créditos personales y de negocios con proyectos de impacto.'
						},
						{
						  property: 'og:description',
						  content: 'La Fintech sostenible de México. Invierte y promueve el desarrollo sostenible en México por medio de créditos personales y de negocios con proyectos de impacto.'
						}
					]
				}
			},
			//=========================== RUTAS NUEVAS PARA EL NUEVO PORTAL
			{
				path: 'credito-pyme',
				name: 'forBusinessPage',
				component: () => import('./views/new-portal-views/ForBusinessPage.vue'),
				meta: {
					title: "Crédito PyME para negocios de impacto.",
					metaTags: [
						{
						  name: 'description',
						  content: 'El Crédito PYME de RedGirasol es un traje a la medida para empresas que tienen un impacto ambiental y social. Conoce las características que lo hacen rápido y eficiente.'
						},
						{
						  property: 'og:description',
						  content: 'El Crédito PYME de RedGirasol es un traje a la medida para empresas que tienen un impacto ambiental y social. Conoce las características que lo hacen rápido y eficiente.'
						}
					]
				},
			},
			{
				path: 'credito-ecotecnologias',
				name: 'forProductsPage',
				component: () => import('./views/new-portal-views/ForProductsPage.vue'),
				meta: {
					title: "Crédito de paneles solares y otras ecotecnologías.",
					metaTags: [
						{
						  name: 'description',
						  content: '¡Flexible, accesible y rápido! Así es el crédito para paneles solares y otras ecotecnologías que tiene Redgirasol para tu casa o negocio.'
						},
						{
						  property: 'og:description',
						  content: '¡Flexible, accesible y rápido! Así es el crédito para paneles solares y otras ecotecnologías que tiene Redgirasol para tu casa o negocio.'
						}
					]
				}
			},
			{
				path: 'credito-personal',
				name: 'forPersonalPage',
				component: () => import('./views/new-portal-views/ForPersonalPage.vue'),
				meta: {
					title: "Crédito personal",
					metaTags: [
						{
						  name: 'description',
						  content: 'Obtén tu Crédito Personal RedGirasol, es rápido y seguro. Solicita tu crédito en línea, es accesible, rápido y con pagos cómodos.'
						},
						{
						  property: 'og:description',
						  content: 'Obtén tu Crédito Personal RedGirasol, es rápido y seguro. Solicita tu crédito en línea, es accesible, rápido y con pagos cómodos.'
						}
					]
				}
			},
			{
				path: 'sostenibilidad-estrategia',
				name: 'strategyPage',
				component: () => import('./views/new-portal-views/StrategyPage.vue'),
				meta: {
					title: "Estrategia para el desarrollo sostenible",
					metaTags: [
						{
						  name: 'description',
						  content: 'Nuestra estrategia cuenta con cuatro enfoques que nos permiten impulsar el desarrollo sostenible en México mediante la movilización de capital.'
						},
						{
						  property: 'og:description',
						  content: 'Nuestra estrategia cuenta con cuatro enfoques que nos permiten impulsar el desarrollo sostenible en México mediante la movilización de capital.'
						}
					]
				}
			},
			{
				path: 'sostenibilidad-impacto',
				name: 'impactPage',
				component: () => import('./views/new-portal-views/ImpactPage.vue'),
				meta: {
					title: "El impacto ambiental y social de La Red.",
					metaTags: [
						{
						  name: 'description',
						  content: 'Inversionistas, solicitantes de crédito y aliados estamos generando un impacto ambiental y social positivo por medio de La Red. Conoce el impacto conseguido en los Objetivos de Desarrollo Sostenible. '
						},
						{
						  property: 'og:description',
						  content: 'Inversionistas, solicitantes de crédito y aliados estamos generando un impacto ambiental y social positivo por medio de La Red. Conoce el impacto conseguido en los Objetivos de Desarrollo Sostenible. '
						}
					]
				}
			},	
			{
				path: 'rendimiento',
				name: 'yieldPage',
				component: () => import('./views/new-portal-views/YieldPage.vue'),
				meta: {
					title: "El rendimiento que buscas está en La Red.",
					metaTags: [
						{
						  name: 'description',
						  content: 'Conoce el rendimiento promedio que generan las inversiones en RedGirasol. Gánale a la inflación y haz crecer tu dinero.'
						},
						{
						  property: 'og:description',
						  content: 'Conoce el rendimiento promedio que generan las inversiones en RedGirasol. Gánale a la inflación y haz crecer tu dinero.'
						}
					]
				}
			},
			{
				path: 'planes-de-inversion',
				name: 'investmentPlansPage',
				component: () => import('./views/new-portal-views/InvestmentPlansPage.vue'),
				meta: {
					title: "Planes de inversion",
					metaTags: [
						{
						  name: 'description',
						  content: 'Conoce los planes de inversión automática que tenemos disponibles. Pon a trabajar tu dinero, organiza tus finanzas y planea tus metas con RedGirasol.'
						},
						{
						  property: 'og:description',
						  content: 'Conoce los planes de inversión automática que tenemos disponibles. Pon a trabajar tu dinero, organiza tus finanzas y planea tus metas con RedGirasol.'
						}
					]
				}
			},			
			// {
			// 	path: 'generica',
			// 	name: 'genericPage',
			// 	component: () => import('./views/new-portal-views/GenericPage.vue'),
			// 	meta: {
			// 		title: "Página generica"
			// 	}
			// },		
			{
				path: 'instaladores',
				name: 'suppliersPage',
				component: () => import('./views/new-portal-views/SuppliersPage.vue'),
				meta: {
					title: "Instaladores",
					metaTags: [
						{
						  name: 'description',
						  content: 'El crédito flexible y accesible que hace posible los proyectos verdes en México. Financiamiento disponible para el usuario final que va adquirir un proyecto o el integrador que lo va a desarrollar.'
						},
						{
						  property: 'og:description',
						  content: 'El crédito flexible y accesible que hace posible los proyectos verdes en México. Financiamiento disponible para el usuario final que va adquirir un proyecto o el integrador que lo va a desarrollar.'
						}
					]
				}
			},
			{
				path: 'reporte-cuitf17',
				name: 'reporteCuitf17',
				component: () => import('@views/ReportCuitf17Page'),
				meta: {
					title: "Reporte CUITF17"
				}
			},
			{
				path: 'comisiones',
				name: 'comisiones',
				component: () => import('./views/ComissionsPage'),
				meta: {
					title: "Comisiones"
				}
			},
			{
				path: 'terminos-y-condiciones',
				name: 'terminosCondiciones',
				component: () => import('@views/TermsContractPage'),
				meta: {
					title: "Términos y condiciones"
				}
			},
			{
				path: 'aviso-de-privacidad',
				name: 'avisoPrivacidad',
				component: () => import('@views/PrivacyContractPage'),
				meta: {
					title: "Aviso de privacidad"
				}
			},
			{
				path: 'politica-de-cookies',
				name: 'politicaCookies',
				component: () => import('@views/PoliticaCookies'),
				meta: {
					title: "Cookies"
				}
			},
			{
				path: 'seguridad',
				name: 'seguridad',
				component: () => import('./views/SecurityAdvices.vue'),
				meta: {
					title: "Sugerencias de seguridad."
				}
			},
			{
				path: 'aclaraciones',
				name: 'aclaraciones',
				component: () => import('./views/Clarifications.vue'),
				meta: {
					title: "Consultas, aclaraciones y reclamaciones."
				}
			},
			{
				path: 'modelo-de-riesgos',
				name: 'calificacion',
				component: () => import('./views/ScorePage.vue'),
				meta: {
					title: "Modelo de riesgos",
					metaTags: [
						{
						  name: 'description',
						  content: 'Conoce el proceso de evaluación, selección y calificación con el que aprobamos los créditos en La Red.'
						},
						{
						  property: 'og:description',
						  content: 'Conoce el proceso de evaluación, selección y calificación con el que aprobamos los créditos en La Red.'
						}
					]
				}
			},
			{
				path: 'cartera',
				name: 'carteraVencida',
				component: () => import('@views/PastDuePortfolio.vue'),
				meta: {
					title: "Mejora continua en nuestra cartera",
					metaTags: [
						{
						  name: 'description',
						  content: 'Conoce cómo ha evolucionado la cartera en La Red gracias a la mejora continua en nuestros modelos de riesgo.'
						},
						{
						  property: 'og:description',
						  content: 'Conoce cómo ha evolucionado la cartera en La Red gracias a la mejora continua en nuestros modelos de riesgo.'
						}
					]
				}
			},
			{
				path: 'buro-entidades-financieras',
				name: 'buroEntidadesFinancieras',
				component: () => import('@views/FinancialEntities.vue'),
				meta: {
					title: "¿Qué es el Buró de Entidades Financieras?"
				}
			},
			{
				path: 'estados-financieros',
				name: 'estadosFinancieros',
				component: () => import('@views/FinancialPage.vue'),
				meta: {
					title: "Estados Financieros"
				}
			},
			{
				path: 'emerge',
				name: 'emerge',
				component: () => import('@views/new-portal-views/emerge/EmergePage.vue'),
				meta: {
					title: "Emerge",
					metaTags: [
						{
						  name: 'description',
						  content: 'EMERGE es una cooperación de desarrollo entre la empresa Coca-Cola FEMSA, RedGirasol y la Cooperación Alemana para el Desarrollo Sustentable (GIZ) en México.'
						},
						{
						  property: 'og:description',
						  content: 'EMERGE es una cooperación de desarrollo entre la empresa Coca-Cola FEMSA, RedGirasol y la Cooperación Alemana para el Desarrollo Sustentable (GIZ) en México.'
						}
					]
				}
			},
			{
				path: 'promotores-inversion',
				name: 'promotersPage',
				component: () => import('@views/new-portal-views/PromotersPage.vue'),
				meta: {
					title: "Promueve la inversión de impacto.",
					metaTags: [
						{
						  name: 'description',
						  content: 'Aprovecha el programa Promotores de Inversión que te bonifica por la inversión fija de tu comunidad, familiares, amigos o conocidos. Conoce cómo funciona, consulta términos y condiciones. '
						},
						{
						  property: 'og:description',
						  content: 'Aprovecha el programa Promotores de Inversión que te bonifica por la inversión fija de tu comunidad, familiares, amigos o conocidos. Conoce cómo funciona, consulta términos y condiciones. '
						}
					]
				}
			},
			{
				path: 'programa-compromiso',
				name: 'loyaltyProgramPage',
				component: () => import('@views/new-portal-views/LoyaltyProgramPage.vue'),
				meta: {
					title: "Tu compromiso es recompensado",
					metaTags: [
						{
						  name: 'description',
						  content: 'Utiliza los planes de inversión de RedGirasol y tu compromiso es recompensado. Cumple los retos y ahorra hasta el 100% de comisiones.'
						},
						{
						  property: 'og:description',
						  content: 'Utiliza los planes de inversión de RedGirasol y tu compromiso es recompensado. Cumple los retos y ahorra hasta el 100% de comisiones.'
						}
					]
				}
			},
			//=========================== RUTAS NUEVAS PARA EL NUEVO PORTAL
			/*{
				path: 'demo1',
				name: 'demo1',
				component: () => import('./views/MainPage')
			},*/

			// {
			// 	path: 'inversionistas',
			// 	name: 'inversionistas',
			// 	component: () => import('./views/InvestorsPage'),
			// 	meta: {
			// 		title: "Inversionistas"
			// 	}
			// },
			// {
			// 	path: 'solicitantes',
			// 	name: 'solicitantes',
			// 	component: () => import('./views/ApplicantsPage'),
			// 	meta: {
			// 		title: "Solicitantes"
			// 	}
			// },
			// {
			// 	path: 'credito-verde',
			// 	name: 'creditoverde',
			// 	component: () => import('./views/GreenCreditPage'),
			// 	meta: {
			// 		title: "Crédito Verde"
			// 	}
			// },
			// {
			// 	path: 'eficiencia-energetica',
			// 	name: 'eficienciaenergetica',
			// 	component: () => import('./views/EficienciaEnergeticaPage'),
			// 	meta: {
			// 		title: "Energía eficiente al alcance de todos."
			// 	}
			// },
			// {
			// 	path: 'instaladores-solares',
			// 	name: 'instaladoressolares',
			// 	component: () => import('./views/InstaladoresSolaresPage'),
			// 	meta: {
			// 		title: "Financiamiento de equipos y materiales solares."
			// 	}
			// },
			// {
			// 	path: 'minado-de-bitcoin',
			// 	name: 'minadodebitcoin',
			// 	component: () => import('./views/MinadoDeBitcoinPage'),
			// 	meta: {
			// 		title: "El futuro de las finanzas hoy lo hacemos verde."
			// 	}
			// },
			// {
			// 	path: 'instaladores',
			// 	name: 'instaladores',
			// 	component: () => import('./views/SuppliersPage'),
			// 	meta: {
			// 		title: "Instaladores"
			// 	}
			// },
			// {
			// 	path: 'faqs',
			// 	name: 'faqs',
			// 	component: () => import('@views/Faqs'),
			// 	meta: {
			// 		title: "Preguntas frecuentes"
			// 	}
			// },
			// {
			// 	path: 'impactamas',
			// 	name: 'impactamas',
			// 	component: () => import('@views/ImpactaMasPage'),
			// 	meta: {
			// 		title: "ImpactaMás"
			// 	}
			// },
			{
				path: 'contrato-de-comision-mercantil-inversionista',
				name: 'contratoMercantilInversionista',
				component: () => import('@views/InvestorMerchantContractPage'),
			},
			{
				path: 'contrato-de-comision-mercantil-cliente',
				name: 'contratoMercantilSolicitante',
				component: () => import('@views/ApplicantMerchantContractPage'),
			},
			{
				path: 'contrato-de-comision-mercantil-instalador',
				name: 'contratoMercantilInstalador',
				component: () => import('@views/SupplierMerchantContractPage'),
			},
			{
				path: 'reporte-robo-extravio',
				name: 'reporteRoboExtravio',
				component: () => import('@views/StealLossReportPage'),
				meta: {
					title: "Reporte de robo"
				}
			},
			{
				path: 'seguimiento-reporte-robo-extravio',
				name: 'seguimientoReporteRoboExtravio',
				component: () => import('@views/StealLossReportFollowUpPage'),
				meta: {
					title: "Seguimiento a reporte de robo"
				}
			},
			// {
			// 	path: 'cocacola',
			// 	name: 'solicitantesKof',
			// 	component: () => import('./views/ApplicantsPageKOF'),
			// 	meta: {
			// 		title: "Cocacola"
			// 	}
			// },
			
			// {
			// 	path: 'recuperados',
			// 	name: 'recuperados',
			// 	component: () => import('./views/RecoveredProjects'),
			// 	meta: {
			// 		title: "Recuperados"
			// 	}
			// },
		]
	},
	// {
	// 	path: '/emerge',
	// 	component: () => import('./layouts/KofLayout'),
	// 	children: [
	// 		{
	// 			path: '',
	// 			name: 'emergeLanding',
	// 			component: () => import('./views/EmergeLandingPage'),
	// 			meta: {
	// 				title: "Emerge / Coca–Cola FEMSA"
	// 			}
	// 		},
	// 	]
	// },
	{
		path: '/login',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL }
	},
	{
		path: '/registro',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL }
	},
	{
		path: '/password/reset',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL }
	},
	{
		path: '/password/reset/:code',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL }
	},
	{
		path: '/preauth/:code',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL }
	},
	{
		path: '/r/:code',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL }
	},
	{
		path: '/cliente/aceptar/:id',
		meta: { redirectBase: process.env.VUE_APP_API_DOMAIN },
	},
	{
		path: '/cliente/aceptar/auth/:id',
		meta: { redirectBase: process.env.VUE_APP_API_DOMAIN },
	},
	{
		path: '/cliente/aceptar/:code/:id',
		meta: { redirectBase: process.env.VUE_APP_API_DOMAIN },
	},
	{
		path: '/tarjetas/:id',
		meta: { redirectBase: process.env.VUE_APP_API_DOMAIN },
	},
	{
		path: '/editar-tarjetas/:id',
		meta: { redirectBase: process.env.VUE_APP_API_DOMAIN },
	},
	{
		path: '/activar-nuevo-vendedor/:token',
		meta: { redirectBase: process.env.VUE_APP_FRONTEND_URL },
	},
	{
		path: '/vendedores/:token',
		meta: {
			redirectFuncUrl: `${process.env.VUE_APP_FRONTEND_URL}/activar-nuevo-vendedor/`,
			redirectParams: ["token"]
		},
	},
	/*{
		path: '/fontello',
		name: 'fontello',
		component: () => import('@views/Fontello'),
	},*/
	{
		path: '*',
		name: 'notFound',
		component: () => import("@views/NotFoundPage"),
		meta: {
			title: 'Página no encontrada',
		}
	},
]

const router = new VueRouter({
	mode: "history",
	base: "",
	routes: routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path === '/auth/callback') return next();
  if (await CognitoAuth.isAuthenticated()) return next();
  await CognitoAuth.login({ from: to.fullPath });
});

router.beforeEach((to, from, next) => {
	if (to.meta.redirectBase) {
		window.location = to.meta.redirectBase + to.fullPath;
	}
	else if(to.meta.redirectFuncUrl){
		let params = [];
		to.meta.redirectParams.forEach(f => {
			params.push(to.params[f])
		});
		window.location = to.meta.redirectFuncUrl + params.join('/');
	}


	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
	const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if(!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags.map(tagDef => {
		const tag = document.createElement('meta');
	
		Object.keys(tagDef).forEach(key => {
		  tag.setAttribute(key, tagDef[key]);
		});
	
		// We use this to track which meta tags we create so we don't interfere with other ones.
		tag.setAttribute('data-vue-router-controlled', '');
	
		return tag;
	  })
	// Add the meta tags to the document head.
	.forEach(tag => document.head.appendChild(tag));

	return next();
});

router.afterEach((to, from) => {
	window.scrollTo(0, 0);
})

export default router;
